import { useState } from "react";

import { publicUserAPI } from "../../api/publicUser";
import { FormSubmissionHandler } from "../../types/common";

import ForgotPasswordForm, {
    ForgotPasswordFormValues,
} from "./components/ForgotPasswordForm";
import ForgotPasswordSuccessMessage from "./components/ForgotPasswordSuccessMessage";

const ForgotPasswordView = (): JSX.Element => {
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit: FormSubmissionHandler<
        ForgotPasswordFormValues
    > = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            await publicUserAPI.forgotPassword(values.email.toLowerCase());
            setIsSuccess(true);
        } catch (err) {
            console.error(err);
        }
        setSubmitting(false);
    };

    return isSuccess ? (
        <ForgotPasswordSuccessMessage />
    ) : (
        <ForgotPasswordForm onSubmit={handleSubmit} />
    );
};

export default ForgotPasswordView;
